import { required } from 'utils/errorsTextHelper';
import * as yup from 'yup';

export const storeSettingsSchema = yup.object().shape({
  productsQuantityFormat: yup.object().shape({
    milSeparator: yup.string().required(required('Million separator')),
    maxDigitsWithoutShorthand: yup
      .number()
      .min(3, 'Max digits without shorthand must be at least 3')
      .required('Max digits without shorthand is required')
  }),
  balanceQuantityFormat: yup.object().shape({
    milSeparator: yup.string().required(required('Million separator')),
    maxDigitsWithoutShorthand: yup
      .number()
      .min(3, 'Max digits without shorthand must be at least 3')
      .required('Max digits without shorthand is required')
  }),
  specialOfferQuantityFormat: yup.object().shape({
    milSeparator: yup.string().required(required('Million separator')),
    maxDigitsWithoutShorthand: yup
      .number()
      .min(3, 'Max digits without shorthand must be at least 3')
      .required('Max digits without shorthand is required')
  }),
  rollingOfferQuantityFormat: yup.object().shape({
    milSeparator: yup.string().required(required('Million separator')),
    maxDigitsWithoutShorthand: yup
      .number()
      .min(3, 'Max digits without shorthand must be at least 3')
      .required('Max digits without shorthand is required')
  })
});
